import PersonaRelatedQuestions from './PersonaRelatedQuestions';

export default PersonaRelatedQuestions;
